const IMG = (id) =>
  `https://static.prod-images.emergentagent.com/jobs/d339d82d-0dd2-4f32-aba3-f3f38b026a7c/images/${id}.jpeg`;

export const IMG_PRODUCTS = {
  'la-fria': IMG('bb03504d5ec992e2d73f784f8346b8c6da4ea5616764b986139f988eaae0ccc7'),
  'linho-misto': IMG('050f59cd1f0aac720dfc5292c59184ee030eb2783b46834f883c0b28f2e5d732'),
  'crepe-dior': IMG('f12c1f5b4a8f97bc7aa3b7022e4711c73480d4a3606b1d13f769e2abe49b4ed4'),
  'tricoline-estampada': IMG('01969036da8e5c8a524ae116475707b35a7227dd1b9a33be7b2767b847350121'),
  'linho-rustico': IMG('4088d154164450d92fd263fa904d07424192a8413961a5a6430ed3a286812c00'),
  'jacquard-geometrico': IMG('b65304308848b7b17d687b84bb72a6279cfa862061cc13da065f09cab9d3be84'),
  'veludo-royal': IMG('901e127be15877a9cea5c26fb1c338673754a3fca2878e08eb75c448067e6059'),
  'tule-bordado': IMG('8f4c17cca6bda0a6e08d9e34cecb145f9561f7ac35c42308167098f1cefc9402'),
  'moletinho-felpado': IMG('c46c9bee621c185a140b30b7a0815d27855839b168344e60af3f80b69b1fb1a1'),
  'ribana': IMG('5972084612c2002c48763e0ab6ef158975e925eff5236609cfbd1a9ca43ec077'),
  'decoracao-linho-rustico': IMG('b2681b8a546bef288bacae68ae7d15f3844b2c8104aa04b448c1e43c0613439f'),
  'oxford-algodao': IMG('32d61c197edf677e90c51dd3077e5cb5e88f245d152181dd186470fe2cdab5c8'),
};
